import React from "react";

export default function Header({ img, img2, alt, txt1, txt2 }) {
  return (
    <div className="header">
      {img && <img src={`${img}`} alt={{ alt }} />}
      {img2 && <img src={`${img2}`} alt={{ alt }} />}
      {txt1 && <p>{txt1}</p>}
      {txt2 && <p>{txt2}</p>}
    </div>
  );
}
